import { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { toast } from 'react-toastify';
import { Form, FormikProvider, useFormik } from 'formik';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useProject } from '../../../Layout/header/context';
import { createSection } from '../../../../../services/sectionService';

const INITIAL_VALUES = {
  name: '',
};

const validationSchema = Yup.object({
  name: Yup.string().required('Section Name is required'),
});

const SectionFormModal = ({ open, projectId, onClose, onSubmit }) => {
  const { projectDetails } = useProject();
  const id = projectId || projectDetails?.id;
  const handleFormikSubmit = async (values, { setSubmitting }) => {
    try {
      // save the section
      const data = { name: values.name, projectId: id };
      const resp = await createSection(data); // success message: response.data.message
      onSubmit(resp?.data?.data);
      toast.success(resp?.data?.message);
    } catch (error) {
      const errMsg =
        error?.response?.data?.message || 'An error occurred while saving the section. Please try again later.';
      toast.error(errMsg);
    } finally {
      setSubmitting(false);
    }
  };
  const formik = useFormik({
    initialValues: INITIAL_VALUES,
    validationSchema,
    onSubmit: handleFormikSubmit,
  });

  const { touched, resetForm, handleSubmit, errors, isSubmitting, getFieldProps } = formik;

  useEffect(() => {
    resetForm();
  }, [open, resetForm]);
  return (
    <Dialog open={open} fullWidth maxWidth={'xs'} onClose={onClose}>
      <FormikProvider value={formik}>
        <Form onSubmit={handleSubmit}>
          <DialogTitle>Add a new section</DialogTitle>
          <DialogContent>
            <TextField
              name="name"
              fullWidth
              autoFocus
              margin="dense"
              id="name"
              {...getFieldProps('name')}
              label="Section Name"
              type="text"
              variant="standard"
              error={Boolean(touched.name && errors.name)}
              helperText={touched.name && errors.name}
            />
          </DialogContent>
          <DialogActions>
            <Button type="button" onClick={onClose}>
              Cancel
            </Button>
            <LoadingButton type="submit" loading={isSubmitting}>
              Add
            </LoadingButton>
          </DialogActions>
        </Form>
      </FormikProvider>
    </Dialog>
  );
};

SectionFormModal.propTypes = {
  open: PropTypes.bool,
  projectId: PropTypes.string,
  onClose: PropTypes.func,
  onSubmit: PropTypes.func,
};

export default SectionFormModal;
